import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}
function ShiMot113({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M19.05 21.85q-1.5 0-2.7-.75L9.4 33.25q4.3 2.6 9.7 2.6 5.45 0 9.8-2.6l-7.05-12.2q-1.25.8-2.8.8M9.6.1Q7.45 1.3 5.65 3.2 0 8.8 0 16.7h13.95v-.25q.1-1.95 1.5-3.35.55-.6 1.2-.9L9.6.1M21 19.9h.1l.6-.6q1.05-1.05 1.05-2.6 0-1.5-1.05-2.6-.5-.45-1-.7-.75-.35-1.65-.35-.95 0-1.7.45-.5.2-.9.6-1.05 1.1-1.05 2.6 0 1.55 1.05 2.6.3.3.6.5v.05q.85.6 2 .6T21 19.9M28.45 0L21.5 12.2q.6.3 1.15.9 1.45 1.4 1.55 3.35v.25h14.05q0-7.9-5.65-13.5-1.9-1.95-4.15-3.2z"
                    id="ShiMot113__Symbol_62_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#ShiMot113__Symbol_62_0_Layer0_0_FILL"
                transform="translate(173.4 265.05)"
                id="ShiMot113__col1n"
            />
        </g></g>
    )
}
export default ShiMot113
